import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAsyncCallback } from '@react-hooks-library/core';

import { getTrialTagsApi } from '@services/trial';
import { setTrialTags } from '@state-mgmt/slices/trial-slice';

export const useGetTrialTags = () => {
  const dispatch = useDispatch();
  return useAsyncCallback(
    useCallback(async (trialId: string | undefined | null) => {
      if (!trialId) {
        dispatch(setTrialTags([]));
        return [];
      }
      try {
        const tagsResposne = await getTrialTagsApi({ trial_id: trialId });

        if (!tagsResposne?.set_tags?.length) {
          dispatch(setTrialTags([]));
          return [];
        }

        dispatch(setTrialTags(tagsResposne.set_tags));
        return tagsResposne.set_tags;
      } catch (error) {
        console.error('Error occurred fetching trial tags.', error);
        dispatch(setTrialTags([]));
        return [];
      }
    }, [])
  );
};
